import { useEffect, useState, memo } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useGetLabelsQuery } from "./labelsApiSlice";

function ShortCutLabelsList(props) {
  const { label } = useGetLabelsQuery("labelsList", {
    selectFromResult: ({ data }) => ({
      label: data?.entities[props.labelId],
    }),
  });
  const [existedLabel, setLabel] = useState(label);
  const [isSelected, setSelect] = useState(props.onChecked);
  function handleCheckState(event) {
    const { checked, name } = event.target;
    setSelect(checked);
    props.onCheckedLabels({ _id: existedLabel.id, name: existedLabel.name });
  }
  useEffect(() => {
    setSelect(props.onChecked);
    setLabel(label);
  }, [props, label]);
  return (
    <FormControlLabel
      control={
        <Checkbox
          name={existedLabel.name}
          checked={!!isSelected}
          onChange={handleCheckState}
        />
      }
      label={existedLabel.name}
    />
  );
}

//export default ShortCutLabelsList;
const memoizedShortCutLabelsList = memo(ShortCutLabelsList);
export default memoizedShortCutLabelsList;
